var _circle, _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconMonitoring = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "#420080"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 9.20072C11.8001 9.20072 9.19922 11.8055 9.19922 15.0101C9.19922 18.2148 11.8001 20.8196 15 20.8196C18.1999 20.8196 20.8008 18.2148 20.8008 15.0101C20.8008 13.4694 20.1896 11.9917 19.1018 10.9023C19.0721 10.8713 19.0365 10.8466 18.9971 10.8295C18.9578 10.8125 18.9154 10.8035 18.8725 10.8031C18.8297 10.8026 18.7871 10.8108 18.7474 10.827C18.7077 10.8432 18.6717 10.8672 18.6414 10.8976C18.611 10.928 18.5871 10.9641 18.5709 11.0038C18.5547 11.0436 18.5465 11.0862 18.547 11.1291C18.5474 11.172 18.5564 11.2145 18.5734 11.2539C18.5904 11.2933 18.6151 11.3289 18.646 11.3587C19.6132 12.3272 20.1562 13.6404 20.1562 15.0101C20.1562 17.8659 17.8515 20.1741 15 20.1741C12.1485 20.1741 9.84375 17.8659 9.84375 15.0101C9.84375 12.1544 12.1485 9.84621 15 9.84621C15.0427 9.84681 15.0851 9.83891 15.1247 9.82296C15.1644 9.80702 15.2004 9.78334 15.2308 9.75331C15.2613 9.72328 15.2854 9.6875 15.3019 9.64804C15.3184 9.60858 15.3269 9.56623 15.3269 9.52346C15.3269 9.48069 15.3184 9.43834 15.3019 9.39889C15.2854 9.35943 15.2613 9.32364 15.2308 9.29362C15.2004 9.26359 15.1644 9.23991 15.1247 9.22396C15.0851 9.20801 15.0427 9.20011 15 9.20072Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.20072C11.8001 9.20072 9.19922 11.8055 9.19922 15.0101C9.19922 18.2148 11.8001 20.8196 15 20.8196C18.1999 20.8196 20.8008 18.2148 20.8008 15.0101C20.8008 13.4694 20.1896 11.9917 19.1018 10.9023C19.0721 10.8713 19.0365 10.8466 18.9971 10.8295C18.9578 10.8125 18.9154 10.8035 18.8725 10.8031C18.8297 10.8026 18.7871 10.8108 18.7474 10.827C18.7077 10.8432 18.6717 10.8672 18.6414 10.8976C18.611 10.928 18.5871 10.9641 18.5709 11.0038C18.5547 11.0436 18.5465 11.0862 18.547 11.1291C18.5474 11.172 18.5564 11.2145 18.5734 11.2539C18.5904 11.2933 18.6151 11.3289 18.646 11.3587C19.6132 12.3272 20.1562 13.6404 20.1562 15.0101C20.1562 17.8659 17.8515 20.1741 15 20.1741C12.1485 20.1741 9.84375 17.8659 9.84375 15.0101C9.84375 12.1544 12.1485 9.84621 15 9.84621C15.0427 9.84681 15.0851 9.83891 15.1247 9.82296C15.1644 9.80702 15.2004 9.78334 15.2308 9.75331C15.2613 9.72328 15.2854 9.6875 15.3019 9.64804C15.3184 9.60858 15.3269 9.56623 15.3269 9.52346C15.3269 9.48069 15.3184 9.43834 15.3019 9.39889C15.2854 9.35943 15.2613 9.32364 15.2308 9.29362C15.2004 9.26359 15.1644 9.23991 15.1247 9.22396C15.0851 9.20801 15.0427 9.20011 15 9.20072Z",
    fill: "#420080",
    stroke: "#420080",
    strokeWidth: 0.8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2873 14.8928L12.5018 14.8928",
    stroke: "#420080",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8945 12.5L14.8945 17.2855",
    stroke: "#420080",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.75,
    height: 13.125,
    fill: "white",
    transform: "translate(8.125 8.125)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMonitoring, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-monitoring.97ad3695.svg";
export { ForwardRef as ReactComponent };